exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bannerBox[data-v-753acc86] {\n  padding-left: 0.15625rem;\n}\n.bannerBox[data-v-753acc86] .avatar-uploader .el-upload {\n  width: 1.291667rem;\n  height: 0.302083rem;\n  border: 0.005208rem dashed #ddd;\n}\n.bannerBox[data-v-753acc86] .avatar-uploader-icon {\n  line-height: 0.302083rem;\n  font-size: 0.104167rem;\n}\n.bannerBox[data-v-753acc86] .avatar {\n  width: 1.291667rem;\n  height: 0.302083rem;\n}", ""]);

// exports
